export default function popUp(images: any, imagesTl: any) {
  if (images.length > 0) {
    imagesTl.from(images, {
      stagger: 0.2,
      scale: 0,
    });
  }
}
